import { InjectionToken } from '@angular/core';

export const WINDOW = new InjectionToken<Window>('WINDOW');
export const GOOGLE_MAPS = new InjectionToken<Promise<typeof google.maps>>('GOOGLE_MAPS');
export const MARKER_CLUSTERER = new InjectionToken<any>('MARKER_CLUSTERER');
